import React from 'react';
import { Award, Users, Wrench, Heart } from 'lucide-react';
import { aboutContent, garageImages } from '../data/mock';

const About = () => {
  const valueIcons = {
    'Expertise': Award,
    'Transparence': Users,
    'Qualité': Wrench,
    'Service personnalisé': Heart
  };

  return (
    <section id="apropos" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block bg-sky-100 text-sky-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              À Propos
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
              {aboutContent.title}
            </h2>
            <p className="text-lg text-sky-600 font-semibold mb-6">
              {aboutContent.description}
            </p>
            
            {aboutContent.paragraphs.map((paragraph, index) => (
              <p key={index} className="text-slate-700 leading-relaxed mb-4">
                {paragraph}
              </p>
            ))}

            {/* Values Grid */}
            <div className="grid grid-cols-2 gap-4 mt-8">
              {aboutContent.values.map((value) => {
                const IconComponent = valueIcons[value.title];
                return (
                  <div key={value.title} className="bg-slate-50 rounded-xl p-4 hover:bg-sky-50 transition-colors">
                    <IconComponent className="text-sky-600 mb-2" size={32} />
                    <h4 className="font-bold text-slate-900 mb-1">{value.title}</h4>
                    <p className="text-sm text-slate-600">{value.description}</p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Images */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="rounded-2xl overflow-hidden shadow-lg h-64">
                  <img
                    src={garageImages.workshop1}
                    alt="Atelier Garage 1225 Sàrl"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="rounded-2xl overflow-hidden shadow-lg h-48">
                  <img
                    src={garageImages.bmwDetail}
                    alt="Service mécanique Garage 1225 Sàrl"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
              </div>
              <div className="space-y-4 mt-8">
                <div className="rounded-2xl overflow-hidden shadow-lg h-48">
                  <img
                    src={garageImages.workshop2}
                    alt="Équipement professionnel Garage 1225 Sàrl"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="rounded-2xl overflow-hidden shadow-lg h-64">
                  <img
                    src={garageImages.bmwLift}
                    alt="Pont élévateur Garage 1225 Sàrl"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
              </div>
            </div>

            {/* Decorative Element */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-br from-sky-200 to-slate-200 rounded-full blur-3xl opacity-50 -z-10"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-gradient-to-br from-slate-200 to-sky-200 rounded-full blur-3xl opacity-50 -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
